import { render, staticRenderFns } from "./TableRequestsLegacyView.vue?vue&type=template&id=37f2ced4"
import script from "./TableRequestsLegacyView.js?vue&type=script&lang=js&external"
export * from "./TableRequestsLegacyView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports